<template>
  <mdb-container>
    <EditNotificationExtra
      :notificationType="notificationType"
    />
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import EditNotificationExtra from "@/components/EditNotificationExtra.vue";
export default {
  name: "AddNotificationExtra",
  components: {
    mdbContainer,
    EditNotificationExtra
  },
  props: {
    notificationType: {
      type: String,
      default: "NOTIFICATION_CATEGORY"
    }
  }
  };
</script> 

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
